export default "__VITE_ASSET__BcaCAa6O__ 600w, __VITE_ASSET__B7MEccA8__ 900w, __VITE_ASSET__hODmLqBm__ 1200w";